import cx from "@hsl/core/utils/cx";
import { type DocObj } from "@hsl/fund-explorer/types";
import dayjs from "@hsl/lgim-explorer/src/lib/dayjs";

import { Translate } from "../../../../../hooks/useTranslation";
import { DATE_FORMAT } from "../DocumentDisplay";

export const LanguageList = ({
    docArr,
    className,
    style,
}: {
    docArr: DocObj[];
    className?: string;
    style?: React.CSSProperties;
}) => {
    return (
        <ul
            className={cx(
                "absolute z-50",
                "bg-super-blue-lightest text-super-blue-dark rounded-sm py-px text-sm shadow-md",
                "ring-1 ring-black ring-opacity-5 focus:outline-none",
                className,
            )}
            style={style}
        >
            {docArr.map((docObj) => (
                <li
                    key={docObj.url}
                    className="cursor-pointer px-4 py-1 hover:font-medium"
                >
                    <a
                        href={docObj.url}
                        target="_blank"
                        className="flex items-center justify-between whitespace-nowrap"
                        rel="noreferrer"
                    >
                        <span className="italic">
                            <Translate>{docObj.lang}</Translate>
                        </span>
                        {docObj.asAtDate && (
                            <span className="pl-2">
                                {" "}
                                {dayjs(docObj?.asAtDate, "YYYY-MM-DD").format(
                                    DATE_FORMAT,
                                )}
                            </span>
                        )}
                    </a>
                </li>
            ))}
        </ul>
    );
};
